import { render, staticRenderFns } from "./SelectCity.vue?vue&type=template&id=1af68531&scoped=true&"
import script from "./SelectCity.vue?vue&type=script&lang=ts&"
export * from "./SelectCity.vue?vue&type=script&lang=ts&"
import style0 from "./SelectCity.vue?vue&type=style&index=0&id=1af68531&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af68531",
  null
  
)

export default component.exports